<template>
    <div>
        <title>总数</title>
        <article class="cardArticle">
            <main class="cardMain">
                <div>
                    <ul class="flexBet totalHead">
                         <li :class="{'active':totalIndex == -1}"  @click="getTotalTab('-1')">
                            <strong>{{ cardBatchStatistics.totalnum }}</strong>
                            <em>总数</em>
                        </li>
                        <li :class="{'active':totalIndex == 0}"  @click="getTotalTab('0')">
                            <strong>{{ cardBatchStatistics.inactivenum }}</strong>
                            <em>未激活</em>
                        </li>
                        <li :class="{'active':totalIndex == 1}"  @click="getTotalTab('1')">
                            <strong>{{ cardBatchStatistics.activenum }}</strong>
                            <em>未提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 2}"  @click="getTotalTab('2')">
                            <strong>{{ cardBatchStatistics.partpicknum }}</strong>
                            <em>部分提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 3}"  @click="getTotalTab('3')">
                            <strong>{{ cardBatchStatistics.ypicknum }}</strong>
                            <em>已提货</em>
                        </li>
                        <li :class="{'active':totalIndex == 5}"  @click="getTotalTab('5')">
                            <strong>{{ cardBatchStatistics.yrecnum }}</strong>
                            <em>已回收</em>
                        </li>
                        <li :class="{'active':totalIndex == 7}"  @click="getTotalTab('7')">
                            <strong>{{ cardBatchStatistics.redefinenum }}</strong>
                            <em>重新出库</em>
                        </li>
                        <li :class="{'active':totalIndex == 4}"  @click="getTotalTab('4')">
                            <strong>{{ cardBatchStatistics.suspennum }}</strong>
                            <em>暂停使用</em>
                        </li>
                        <!-- <li :class="{'active':totalIndex == 6}"  @click="getTotalTab('6')">
                            <strong>{{ cardBatchStatistics.yzfnum }}</strong>
                            <em>已作废</em>
                        </li> -->
                    </ul>
                    <!-- S 检索 -->
                    <el-form :model="totalForm" :inline="true" class="searchForm totalForm">
                        <el-form-item label="券卡编码" class="codeSerIpt">
                            <el-input v-model="totalForm.code" clearable placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="totalForm.state" placeholder="请选择" clearable>
                                <el-option label="未激活" value="0"></el-option>
                                <el-option label="未提货" value="1"></el-option>
                                <el-option label="部分提货" value="2"></el-option>
                                <el-option label="已提货" value="3"></el-option>
                                <el-option label="已回收" value="5"></el-option>
                                <el-option label="重新出库" value="7"></el-option>
                                <el-option label="已暂停使用" value="4"></el-option>
                                <!-- <el-option label="已作废" value="6"></el-option> -->
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号码">
                            <el-input v-model="totalForm.phone" clearable placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="query">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" plain @click="goBack">返回</el-button>
                        </el-form-item>
                        <p class="greyColor totalMsg" v-if="totalIndex == -1"><i class="iconbulb"></i>已有<b class="commonNum">{{cardBatchStatistics.yrecnum +cardBatchStatistics.redefinenum }}</b>张券卡被重新出库或者回收再次出库！</p>
                    </el-form>
                    <!-- E 检索 -->
                </div>
                <section class="totalCon">
                    <!-- S 表格 -->
                    <el-table ref="gsTable" class="comTable totalTable recordTable" border  v-loading="vloading" :data="cardBatchCodeList" :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index"></el-table-column>
                        <el-table-column label="券卡编码" fixed width="200" prop="code">
                            <template slot-scope="scope">
                                <p>{{scope.row.code}}</p>
                                <em v-if="scope.row.serial">【{{scope.row.serial}}】</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="手机号码" fixed width="170" prop="phone">
                            <template slot-scope="scope">
                                    {{scope.row.phone || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="statetype" width="120" fixed prop="state">
                            <template slot-scope="scope">
                                <span class="orangeColor" v-if="scope.row.state == 0 || scope.row.state == 1">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greenColor" v-else-if="scope.row.state == 2 || scope.row.state == 5 || scope.row.state == 7">{{scope.row.state | cardStateFilter}}</span>
                                <span class="redColor" v-else-if="scope.row.state == 4 || scope.row.state == 6">{{scope.row.state | cardStateFilter}}</span>
                                <span class="blueColor" v-else-if="scope.row.state == 3">{{scope.row.state | cardStateFilter}}</span>
                                <span class="greyColor" v-else>{{scope.row.state | cardStateFilter}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="付款状态" width="120" prop="paystate">
                            <template slot-scope="scope">
                                {{scope.row.paystatus | cardPpayStateFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡类型" width="100">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义类型" width="200">
                            <template slot-scope="scope">
                                {{scope.row.deftype | cardTypeFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡流向" width="150">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.lflowname">{{scope.row.lflowname ||'门店直发'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="专区数量" sortable width="100" prop="selzones">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.selzones==0||''?1:scope.row.selzones}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="共可选择商品数" sortable width="150" prop="selnum">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.selnum || '0'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="可使用次数" sortable width="120" prop="usenum">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.usenum || '0'}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="默认商品" width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.defaultgoodsname">{{scope.row.defaultgoodsname || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡面值 (￥)" sortable width="130" prop="cardprice">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.cardprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="券卡售价 (￥)" sortable width="130" prop="cardsmallprice">
                            <template slot-scope="scope">
                                <em class="priceFont">{{scope.row.lcardsmallprice | formatAmount}}</em>
                            </template>
                        </el-table-column>
                        <el-table-column label="有效期" width="120">
                            <template slot-scope="scope">
                                 <p class="serial" v-if="scope.row.startvaldate">
                                    {{dateTime(scope.row.startvaldate)}}
                                  <em>~</em>
                                            {{dateTime(scope.row.endvaldate)}}
                                      </p>
                                      <p class="serial" v-else>
                                            长期有效
                              </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="客服备注" width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="面单打印备注" width="200">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.printmemo">{{scope.row.printmemo || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="130" fixed="right">
                            <template slot-scope="scope">
                               <!-- <el-dropdown placement="bottom-start" @command="getCommand" trigger="click">
                                    <span class="el-dropdown-link" @click="allBatchcode(scope.row)">
                                    全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="getCoverDetailShow">详情</el-dropdown-item>
                                        <el-dropdown-item command="2" v-if="scope.row.state==1||scope.row.state==2">暂停</el-dropdown-item>
                                        <el-dropdown-item command="3" v-if="scope.row.state==4">恢复</el-dropdown-item>
                                         <el-dropdown-item command="5" v-if="scope.row.lflowcode==0">短信重发</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown> -->
                                <p class="handle">
                                  <span title="详情" @click="getCoverDetailShow(scope.row)"><i class="icondetails"></i></span>
                                  <span v-if="totalIndex!=5&&(scope.row.state==1||scope.row.state==2)" title="暂停使用" @click="getRecoverShow(2,scope.row)"><i class="iconzt"></i></span>
                                <span v-if="totalIndex!=5&&scope.row.state==4" title="恢复使用" @click="getRecoverShow(3,scope.row)"><i class="iconchexiao"></i></span>
                                <span v-if="totalIndex<2&&ecardrecvtype==0&&(scope.row.state==1||scope.row.state==0)" title="回收" @click="getRecoverShow(4,scope.row)"><i class="iconshbtg"></i></span>
                                <span v-show="totalIndex!=5&&ecardrecvtype==0&&scope.row.state==1&&totalForm.state!=5"  title="短信重发" @click="resendMsg(scope.row.phone,scope.row.code)"><i class="iconmsg"></i></span>
                                </p>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
                    </el-table>
                    <!-- E 表格 -->
                </section>
                 <!-- S 暂停、恢复弹框 -->
                    <el-dialog class="comDlog recoverDlog" title="提示" :visible.sync="recoverDialogVisible" :close-on-click-modal="false" append-to-body>
                       <!-- <p>当前可{{operateTxt}}数量：<i class="pink commonNum">{{num}}</i></p>-->
                        <p>确定要进行{{operateTxt}}操作吗？</p>
                        <p v-show="types==4" class="redColor">电子券回收后将永久作废，无法恢复使用。请谨慎操作！</p>
                        <el-input type="textarea" v-model="recoverMemo"  maxlength="100" :placeholder='"输入"+operateTxt+"备注"'></el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary"  :loading="showbutton"  @click="getCoverSuccessShow(true)">确定</el-button>
                            <el-button   @click="getRecoverShow(false)">取消</el-button>
                        </span>
                    </el-dialog>
                    <!-- E 暂停、恢复弹框 -->
                    <!-- E 暂停、恢复成功弹框 -->
                <!-- S 出库详情弹框 -->
                <OutDetail :cardInfo="cardInfo" :outDetailDialogVisible="outDetailDialogVisible"  @closeChild="getCloseOutDetailCld"></OutDetail>
                <!-- E 出库详情弹框 -->
                <!-- S 分页 -->
                    <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                    <!-- E 分页 -->
            </main>
        </article>

    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { Message, MessageBox } from "element-ui";
export default {
    name:'CardRecordTotal',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
    },
    filters:{
        // 券卡当前状态
        stateFilter(val){
            if(val == 0){
                return '未激活'
            }else if(val == 1){
                return '未提货'
            }else if(val == 2){
                return '部分提货'
            }else if(val == 3){
                return '已提货'
            }else if(val == 4){
                return '已回收'
            }else if(val == 5){
                return '重新出库'
            }else if(val == 6){
                return '已暂停使用'
            }else if(val == 7){
                return '已作废'
            }
        }
    },
    data(){
        return{
            ecardrecvtype:null,
            showbutton:false,
            vloading:false,
            statetype:'当前状态',
            cardInfo:'',
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            batchcode:'',
            cardBatchStatistics:'',
            cardBatchCodeList:[],
            // 检索表单
            totalForm:{
                code:'',//关键词
                state:'',//状态
                phone:'',
            },
            outDetailDialogVisible:false,//出库详情弹框
            totalIndex:-1,//当前选中总数
            tableHeight: window.innerHeight*.8, //表格动态高度
            recoverMemo:'',
            times:'',
            recoverDialogVisible:false,//修改的弹框
            operateTxt :'',
            num:0,
            types:'',
            batchOtherOper:'',
        }
    },
    watch: {
      "totalForm.state":function(val){
          if(val=='5'){
              this.statetype = '回收前状态';
            } else if(val=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
            this.pageSize =30;
          this.currentPage =1;
          this.getCardBatchCodeList();
      }
    },
    // ==================================== 方法 ====================================
    methods:{
        // allBatchcode(times){
        //   this.recoverMemo = '';
        //   this.times = times;
        // },
        // // 下拉菜单事件
        // getCommand(command){
        //   this.types= command;
        //   if(command == 'getCoverDetailShow'){
        //       this.getCoverDetailShow(this.times);
        //       return
        //   }
        //   if(command == "2"){
        //     // 暂停
        //     this.getRecoverShow('暂停');
        // }else if(command == "3"){
        //     // 暂停
        //     this.getRecoverShow('恢复');
        // }else  if(command == "5"){ //短信重发
        //      this.resendMsg(this.times.phone,this.times.code);
        // }
        // },
        // 回收、暂停、恢复
        getRecoverShow(val,row) {
            this.recoverMemo = '';
            this.times = row;
            if(val != false){
                this.operateTxt = (val==2) ? '暂停' : (val==3?'恢复':'');
                this.types = val;
                this.recoverDialogVisible = true;
            }else{
                this.recoverDialogVisible = false;
            }
        },
        getCoverSuccessShow(val){
            if(val==false){
               this.recoverDialogVisible = false;
               return
            }
            this.showbutton = true;
            let param = {
                  batchcode:this.batchcode,
                  code:this.times.code,
                  memo:this.recoverMemo,
                  opertype:this.types,
            }
            if(this.types==2||this.types==3){
              Api.ECODEINFOSUSPENDORRECOVER(param).then(res =>{
                 this.showbutton = false;
                  if(res.data.status=="200"){
                    this.$message.success(res.data.message);
                    this.recoverDialogVisible = false;
                    this.getCardBatchCodeList();
                    this.getCardBatchStatistics();
                  }else{
                    this.$message.error(res.data.message);
                  }
              }).catch((err)=>{
                 this.showbutton = false;
              })
            }else if(this.types==4){
              let paramS = {
                  code:this.times.code,
                  memo:this.recoverMemo,
            }
              Api.SMSBATCHSINGLECARDCYCLE(paramS).then(res =>{
                 this.showbutton = false;
                  if(res.data.status=="200"){
                    this.$message.success(res.data.message);
                    this.recoverDialogVisible = false;
                    this.getCardBatchCodeList();
                    this.getCardBatchStatistics();
                  }else{
                    this.$message.error(res.data.message);
                  }
              }).catch((err)=>{
                 this.showbutton = false;
              })
            }
        },
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 打开出库详情弹框
        getCoverDetailShow(code){
          this.cardInfo =code;
          this.outDetailDialogVisible = true;
          // Api.GET_CARDINFODET({code:code}).then(res =>{
          //    if(res.data.status=="200"){
          //      if(res.data.data.codeinfo){
          //        this.cardInfo =res.data.data.codeinfo;
          //        this.outDetailDialogVisible = true;
          //      }
          //    }
          // })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
        },
        // 切换各种状态
        getTotalTab(totalIndex){
            if(totalIndex=='5'){
              this.statetype = '回收前状态';
            } else if(totalIndex=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
            this.totalIndex = totalIndex;
            if(totalIndex==-1){
               this.totalForm.state = '';
            }else{
               this.totalForm.state = totalIndex;
            }
            this.getCardBatchCodeList();
        },
        // 返回上一页
        goBack(){
            window.history.back();
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 125;
        },
        // 数量
        getCardBatchStatistics(){
          let param ={
            batchcode:this.batchcode,
            opertype:0
          }
          Api.GET_CARDBATCHSTATISTICS(param).then(res =>{
            if(res.data.status=="200"){
              this.cardBatchStatistics = res.data.data;
            }else{
              this.cardBatchStatistics= '';
            }
          })
        },
        // 批次内编码详情列表
        getCardBatchCodeList(){
          let param = {
                 batchcode:this.batchcode,
                 opertype:0,
                 state:this.totalForm.state,
                 phone:this.totalForm.phone,
                 cardmedium:1,
                 code:this.totalForm.code,
                 pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
              }
          }
          this.vloading = true;
          Api.GET_CARDBATCHCODELIST(param).then(res =>{
              if(res.data.status=="200"){
                 this.vloading = false;
                 this.cardBatchCodeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                this.vloading = false;
                 this.pageTotal =0;
                 this.cardBatchCodeList =[];
              }
          })
        },
        // 短信
        resendMsg(phone,code){
          let param = {
              code:code,
              sendtype:1,
              phone:phone,
              cardmedium:1
          }
          MessageBox.confirm('确定短信重发？', '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            type: 'success'
          }).then(() => {
              Api.RESENDMSG(param).then(res =>{
                  if(res.data.status=="200"){
                    this.$message.success(res.data.message);
                  }else{
                    this.$message.error(res.data.message);
                  }
              })
          }).catch(() => {});
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
         if(this.$route.query.batchcode){
            this.batchcode = this.$route.query.batchcode;
            this.ecardrecvtype =this.$route.query.ecardrecvtype
            this.getCardBatchStatistics();
            this.getCardBatchCodeList();
         }
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.cardArticle{
    position: relative;
    padding: 20px 20px 20px 20px;
    height: calc(100% - 169px);
}
/* S 头部数量统计 */
.totalHead{
    width: 100%;
    height: 100px;
    background: #F5F7FA;
}
.totalHead li{
    position: relative;
    text-align: center;
    width: 11.1%;
    cursor: pointer;
}
.totalHead li::after{
    content: '';
    position: absolute;
    width: 1px;
    height: 60px;
    background: #DCDFE6;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
}
.totalHead li:last-child::after{
    display: none;
}
.totalHead li strong{
    color: #333;
    font-size: 28px;
    font-family: "PingFang SC", "Microsoft YaHei", Arial, Verdana;
}
.totalHead li em{
    color: #666;
    display: block;
    margin-top: 5px;
}
.totalHead .active strong{
    font-weight: bold;
}
/* E 头部数量统计 */
/* S 检索 */
.totalMsg{
    font-size: 12px;
    display: inline-block;
    line-height: 40px;
    border: none;
    width: auto;
}
.totalMsg i{
    color: #F2962C;
    font-size: 16px;
    margin-right: 5px;
}
.totalMsg b{
    color: #F7615E;
    font-weight: bold;
    margin: 0 3px;
    font-size: 14px;
}
.totalForm{
    margin: 20px 0;
}
.totalForm>>>.el-form-item{margin-bottom: 0!important;}
/* E 检索 */
/* S 表格 */
.totalTable tr:last-child td{
    border-bottom: none;
}
/* .totalTable>>>th:last-child .cell,
.totalTable>>>td:last-child .cell,
.totalTable>>>th:first-child .cell,
.totalTable>>>td:first-child .cell{
    text-align: center;
} */
.totalTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.totalTable .icondetails{
    font-size: 18px;
}
/* E 表格 */
.recordTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
.recordTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.recordTable>>>td:nth-child(5) .cell{
    overflow: initial;
}
/* S 回收弹框 */
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
.pink{
    color: #F7615E;
    font-weight: bold;
    margin: 0 5px;
}
.el-icon-warning{
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
}
.coverSuccess p{
    margin-bottom: 5px;
}
.coverSuccess em{
    display: block;
    line-height: 1.5;
}
/* E 回收弹框 */
.iconwx {font-size: 16px;}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsElectron/CardRecord/ElectronRecordOutTotal.vue